export default __webpack_public_path__ + "static/media/cart.1712979d.svg";